export default {
  sharedNavRoutes: [
    {text: 'Home', url: '/portal', isStatic: false},
    {text: 'Pipeline', url: '/portal/pipeline', isStatic: false},
    {text: 'Portfolio', url: '/portal/portfolio', isStatic: false}
  ],
  logoutRoute: {text: 'Sign Out', url: '/portal/sign_out', isStatic: false},
  singleSubmissionRoute: {text: 'New Submission', url: '/portal/new_submission', isStatic: false, customClass: 'nav-submission single'},
  dualSubmissionRoutes:
  {
    text: 'New Submission', customClass: 'nav-submission dual', navItems: [
      {text: "Standard Form", url: '/portal/new_submission', isStatic: false},
      {text: "Shortened Form", url: '/portal/shortened_submission', isStatic: false}
    ]
  },
  logoRoute: '/portal'
};
